/**
 * MetaStrip — die Kennzeile unter dem Apartmentnamen.
 *
 * Format: „Passau · 2 von 2 Kanälen aktiv · 4 Schlafplätze · 1 Schlafzimmer · 1 Bad ·
 * Reinigung 45,00 €". Punkte als Trenner, kein Icon-Beiwerk.
 */
import { cn } from '@/shared/lib/cn';
import { formatMoney } from '@/shared/lib/format';

interface MetaStripProps {
  city: string;
  channelsActive: number;
  channelsTotal: number;
  channexConnected: boolean;
  guests: number;
  bedrooms: number;
  bathrooms: number;
  cleaningFee: number;
  currency: string;
}

export function MetaStrip({
  city,
  channelsActive,
  channelsTotal,
  channexConnected,
  guests,
  bedrooms,
  bathrooms,
  cleaningFee,
  currency,
}: MetaStripProps) {
  return (
    <p className="text-ink-soft mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px]">
      <MetaItem>{city}</MetaItem>
      <Divider />
      {channexConnected ? (
        <MetaItem highlight={channelsTotal > 0 && channelsActive === channelsTotal}>
          {channelsTotal === 0
            ? 'Kein Buchungsportal verbunden'
            : `${channelsActive} von ${channelsTotal} Kanälen aktiv`}
        </MetaItem>
      ) : (
        <MetaItem muted>Nicht beim Kanalmanager</MetaItem>
      )}
      <Divider />
      <MetaItem>
        {guests} {guests === 1 ? 'Schlafplatz' : 'Schlafplätze'}
      </MetaItem>
      <Divider />
      <MetaItem>
        {bedrooms} Schlafzimmer · {bathrooms} {bathrooms === 1 ? 'Bad' : 'Bäder'}
      </MetaItem>
      <Divider />
      <MetaItem>Reinigung {formatMoney(cleaningFee, currency)}</MetaItem>
    </p>
  );
}

function Divider() {
  return (
    <span className="text-ink-faint" aria-hidden>
      ·
    </span>
  );
}

function MetaItem({
  children,
  muted,
  highlight,
}: {
  children: React.ReactNode;
  muted?: boolean;
  highlight?: boolean;
}) {
  return (
    <span className={cn(highlight && 'text-sage font-medium', muted && 'text-ink-faint')}>
      {children}
    </span>
  );
}
